export default "__VITE_ASSET__CBkqNZSp__"